import SegmentUtils from 'utils/segment';
import getTopSearchResults from '../utils/top-search-results';

export default function trackSearchResultsList({
    spots,
    filters,
    sortBy,
    isMonthly,
}) {
    const properties = {
        top_search_results_list: getTopSearchResults({
            filters,
            spots,
            isMonthly,
            sortBy,
        }).topSpots,
    };

    SegmentUtils.track({
        event: 'Search Results List',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
